const CloseOrderButton = ({ handleClick }) => (
	<a className="close-button" onClick={() => handleClick(true)}>
		<button className="button-sm btn-orange">Close Open Orders</button>
	</a>
);

export default CloseOrderButton;
